// extracted by mini-css-extract-plugin
export default {"errorBoundaryTitle":"ErrorBoundary_errorBoundaryTitle__vRdST","errorBoundaryMessage":"ErrorBoundary_errorBoundaryMessage__UJs7o"};